import { ref, computed } from 'vue';
import { throttle } from 'lodash';

let isInitialized = false;

const BREAKPOINTS = {
  XL: 1280,
  LG: 1024,
  MD: 768,
  SM: 576,
};

// Глобальное состояние
const screenWidth = ref(typeof window !== 'undefined' ? window.innerWidth : 0);

// Троттлинг-обработчик
const handleResize = throttle(() => {
  screenWidth.value = window.innerWidth;
}, 500);

/**
 * Инициализирует глобальный слушатель resize
 * @returns {void}
 */
export function initScreenResize() {
  if (isInitialized || typeof window === 'undefined') return;
  
  screenWidth.value = window.innerWidth;
  window.addEventListener('resize', handleResize);
  isInitialized = true;
}

/**
 * Очищает глобальный слушатель
 * @returns {void}
 */
export function cleanupScreenResize() {
  if (!isInitialized || typeof window === 'undefined') return;
  
  window.removeEventListener('resize', handleResize);
  handleResize.cancel();
  isInitialized = false;
}

// Общие computed-свойства
export const isLessThanXL = computed(() => screenWidth.value <= BREAKPOINTS.XL);
export const isLessThanLG = computed(() => screenWidth.value <= BREAKPOINTS.LG);
export const isLessThanMD = computed(() => screenWidth.value <= BREAKPOINTS.MD);
export const isLessThanSM = computed(() => screenWidth.value <= BREAKPOINTS.SM);
export const currentBreakpoint = computed(() => {
  if (screenWidth.value >= BREAKPOINTS.XL) return 'xl';
  if (screenWidth.value >= BREAKPOINTS.LG) return 'lg';
  if (screenWidth.value >= BREAKPOINTS.MD) return 'md';
  if (screenWidth.value >= BREAKPOINTS.SM) return 'sm';
  return 'xs';
});

/**
 * Composable для доступа к общим computed-свойствам
 * @returns {Object} Реактивные свойства
 */
export function useScreenSize() {
  return {
    isLessThanXL,
    isLessThanLG,
    isLessThanMD,
    isLessThanSM,
    currentBreakpoint,
    screenWidth
  };
}